import { getRandomInt } from '@/utils/getRandomBetweenRange'

/**
 * This return a random element from the array
 * @param array
 * @returns {*}
 */
export default array => {
  const index = getRandomInt(0, array.length)
  return array[index]
}
